import CaseOpenLink from 'components/CaseOpenLink';
import React from 'react';

interface Props {
  caseId?: number;
  children: React.ReactNode;
}

/**
 * Regnumret i ruttplaneringen öppnar hela ärendet ovanpå förslaget, så markeringar och
 * scrollläge står kvar när det stängs. Förslag sparade innan fältet fanns har caseId 0 —
 * då blir det vanlig text.
 */
const CaseRegLink: React.FC<Props> = ({ caseId, children }) =>
  caseId ? <CaseOpenLink caseID={caseId}>{children}</CaseOpenLink> : <span>{children}</span>;

export default CaseRegLink;
